let postLoginSideBar = [
    { menu: { label: 'My Portfolio', linkTo: `/portfolio`, class: "myportfolio_navicon" }, },

    {
        menu: { label: 'Invest', linkTo: `/transact`, class: "invest_navicon" },
        subMenu: [
            { menu: { label: 'Quick Invest', linkTo: `/transact/quick-invest`, class: "xyz" }, },
            { menu: { label: 'Lumpsum', linkTo: `/transact/lumpsum-invested-funds`, class: "xyz" }, },
            { menu: { label: 'Lumpsum - Cashflow', linkTo: `/transact/lumpsum-cashflow`, class: "xyz" }, },
            { menu: { label: 'SIP', linkTo: `/sip/select-fund`, class: "xyz" }, },
            {
                menu: {
                    label: "Create Folio",
                    linkTo: `/onboarding/personal`,
                    class: "xyz",
                },
            },
        ]
    },
    // {
    //     menu: { label: 'Allocate in Demat', linkTo: ``, class: "aldemat_navicon" },
    //     subMenu: [
    //         { menu: { label: 'Lumpsum', linkTo: ``, class: "_ac" }, },
    //         { menu: { label: 'SIP', linkTo: ``, class: "_ac" }, },
    //     ]
    // },
    //{ menu: { label: 'Goal Based Investment', linkTo: ``, class:"goalbase_navicon" }, },
    {
        menu: { label: 'Redemption', linkTo: ``, class: "redemption_navicon" },
        subMenu: [
            { menu: { label: 'Sell', linkTo: `/transact/sell`, class: "_ac" }, },
            { menu: { label: 'SWP', linkTo: `/transact/SWP`, class: "_ac" }, },
        ]
    },
    {
        menu: { label: 'Transfer', linkTo: ``, class: "transfer_navicon" },
        subMenu: [
            { menu: { label: 'Switch', linkTo: `/transact/switch`, class: "_ac" }, },
            { menu: { label: 'STP', linkTo: `/transact/stp`, class: "_ac" }, },
        ]
    },
    {
        menu: { label: 'Scheduled Investments', linkTo: ``, class: "mnschedule_navicon" },
        subMenu: [
            {
                menu: {
                    label: 'SIP', linkTo: '/schedule-investments/sip', class: "_ac"
                }
            },
            {
                menu: {
                    label: 'SWP', linkTo: '/schedule-investments/swp', class: "_ac"
                }
            },
            {
                menu: {
                    label: 'STP', linkTo: '/schedule-investments/stp', class: "_ac"
                }
            },
        ]
    },
    // {
    //     menu: { label: 'Smart Plans', linkTo: ``, class: "smartplan_navicon" },
    //     subMenu: [
    //         { menu: { label: 'Movi pack plan', linkTo: ``, class: "_ac" }, },
    //         { menu: { label: 'Cash flow plan', linkTo: ``, class: "_ac" }, },
    //         { menu: { label: 'Large cap alpha index plan', linkTo: ``, class: "_ac" }, },
    //     ]
    // },

    { menu: { label: 'Orderbook', linkTo: `/orderbook`, class: "orderbook_navicon" }, },
    // {
    //     menu: { label: 'Manage Profile', linkTo: ``, class: "managepr_navicon" },
    //     subMenu: [
    //         { menu: { label: 'Change password', linkTo: ``, class: "_ac" }, },
    //         { menu: { label: 'Hint Question', linkTo: ``, class: "_ac" }, },
    //         { menu: { label: 'Email/Mobile', linkTo: ``, class: "_ac" }, },
    //     ]
    // },
    {
        menu: { label: 'Reports', linkTo: ``, class: "report_navicon" },
        subMenu: [
            { menu: { label: 'SIP Reports', linkTo: `/reports/sip-report`, class: "_ac" }, },
            { menu: { label: 'Capital Gain / Loss Statement', linkTo: `/reports/capital-gain-loss`, class: "_ac" }, },
            { menu: { label: 'Account Statement', linkTo: `/reports/account-statement`, class: "_ac" }, },

        ]
    },
    {
        menu: { label: 'Manage Account', linkTo: ``, class: "manageac_navicon" },
        subMenu: [
            { menu: { label: 'Add Bank', linkTo: `/manage-account/add-new-bank`, class: "_ac" }, },
            { menu: { label: 'Add Mandate', linkTo: `/manage-account/add-new-mandate`, class: "_ac" }, },
            { menu: { label: 'Manage Nominee', linkTo: `/manage-account/nomineeManage`, class: "_ac" }, },

        ]
    },
];

export default postLoginSideBar;